export default "/_next/static/197ddaf57cc11b9b042fa5338165236f.png";